import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ShieldCheck, LogOut } from "lucide-react";
import { toast } from "sonner";

export default function CambioPassword() {
  const { user, setUser, logout } = useAuth();
  const [f, setF] = useState({ cur: "", p1: "", p2: "" });
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (f.p1.length < 8) { setErr("La nuova password deve contenere almeno 8 caratteri."); return; }
    if (f.p1 !== f.p2) { setErr("Le due password non coincidono."); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: f.cur, new_password: f.p1 });
      toast.success("Password aggiornata. Benvenuto!");
      setUser({ ...user, must_change_password: false });
    } catch (ex) {
      setErr(formatApiError(ex.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-10" data-testid="cambio-password-page">
      <form onSubmit={submit} className="w-full max-w-md rounded-2xl border bg-white p-6 shadow-sm sm:p-8">
        <img src="/indar-logo.png" alt="INDAR" className="h-10 w-auto" />
        <div className="mt-6 flex items-center gap-2 text-[#E11D48]"><ShieldCheck className="h-5 w-5" /><span className="text-xs font-semibold uppercase tracking-wide">Primo accesso</span></div>
        <h1 className="mt-1 font-display text-2xl font-bold text-slate-900">Scegli la tua password</h1>
        <p className="mt-1 text-sm text-slate-500">
          La password di <span className="font-medium text-slate-700">{user.email}</span> è stata reimpostata dall'amministratore. Per continuare scegline una personale.
        </p>
        <div className="mt-6 space-y-4">
          <div>
            <Label className="text-xs font-semibold uppercase text-slate-500">Password ricevuta</Label>
            <Input type="password" autoComplete="current-password" value={f.cur} onChange={(e) => setF({ ...f, cur: e.target.value })} className="mt-1" data-testid="cp-current" />
          </div>
          <div>
            <Label className="text-xs font-semibold uppercase text-slate-500">Nuova password (min. 8 caratteri)</Label>
            <Input type="password" autoComplete="new-password" value={f.p1} onChange={(e) => setF({ ...f, p1: e.target.value })} className="mt-1" data-testid="cp-new" />
          </div>
          <div>
            <Label className="text-xs font-semibold uppercase text-slate-500">Conferma nuova password</Label>
            <Input type="password" autoComplete="new-password" value={f.p2} onChange={(e) => setF({ ...f, p2: e.target.value })} className="mt-1" data-testid="cp-confirm" />
          </div>
          {err && <p className="rounded-lg bg-rose-50 p-3 text-sm text-rose-700" data-testid="cp-error">{err}</p>}
        </div>
        <Button type="submit" disabled={saving} className="mt-6 h-11 w-full bg-[#E11D48] hover:bg-[#BE123C]" data-testid="cp-save">
          {saving && <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />} Salva e continua
        </Button>
        <button type="button" onClick={logout} className="mt-3 flex w-full items-center justify-center gap-1.5 py-2 text-sm text-slate-500 hover:text-slate-900" data-testid="cp-logout">
          <LogOut className="h-4 w-4" /> Esci
        </button>
      </form>
    </div>
  );
}
